import React, { Component } from 'react';
import ResizableRect from 'react-resizable-rotatable-draggable-touch-v2';  
   
   class SelectionBox extends Component {
        constructor() {
          super()
          
          
          let left = window.innerWidth/4;
          let top = window.innerHeight/4;
          
          this.state = {
            width: 100,
            height: 100,
            top: top,
            left: left,
            rotateAngle: 0
          }
          this.handleResize = this.handleResize.bind(this);
          this.handleRotate = this.handleRotate.bind(this);
          this.handleDrag = this.handleDrag.bind(this);
        }

        handleResize(style, isShiftKey, type) {
            let { top, left, width, height } = style
            top = Math.round(top)
            left = Math.round(left)
            width = Math.round(width)
            height = Math.round(height)
            this.setState({
              top,
              left,
              width,
              height
            })
        }
              
        handleRotate (rotateAngle) {
          this.setState({
            rotateAngle
          })
        }
      
        handleDrag (deltaX, deltaY) {
          this.setState({
            left: this.state.left + deltaX,
            top: this.state.top + deltaY
          })
        }
      
        render() {
          const {width, top, left, height, rotateAngle} = this.state
          return (
            <div className="App">
              <ResizableRect
                left={left}
                top={top}
                width={width}
                height={height}
                rotateAngle={rotateAngle}
                // aspectRatio={false}
                // minWidth={10}
                // minHeight={10}
                zoomable='n, w, s, e, nw, ne, se, sw'
                // rotatable={true}
                // onRotateStart={this.handleRotateStart}
                // onRotate={this.handleRotate}
                // onRotateEnd={this.handleRotateEnd}
                // onResizeStart={this.handleResizeStart}
                onResize={this.handleResize}
                // onResizeEnd={this.handleUp}
                // onDragStart={this.handleDragStart}
                onDrag={this.handleDrag}
                // onDragEnd={this.handleDragEnd}
              />
            </div>
          )
        }
        // render() {
        //     return <h2>hp!</h2>;
        // }
    }

export default SelectionBox;


// WEBPACK FOOTER //
// ./frontend/web/js/SelectionBox.js